var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('home-header'),_c('div',{staticClass:"base-padding"},[_c('home-menu'),_c('home-amap')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }